module.exports = __webpack_public_path__ + "static/ACH-Authorization-Form-a088e07858d68232f11041b129062f15.pdf";